import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import dayjs from 'dayjs';
import TablePaymentHistory from '../components/DataTableUser/TablePaymentHistory';
import api from '../utils/functions/api';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Grid } from '@mui/material'
import PaymentListApi from '../service/payment.api';

const textFieldStyles = {
  [`& fieldset`]: {
    borderRadius: 30,
  },
  [`md`]: {},
};

function PaymentList() {
  const [paymentListUser, setPaymentListUser] = useState([]);
  const [roleUser, setRoleUser] = useState('CUSTOMER');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState(
    null,
    // dayjs().startOf('month').format('YYYYMMDDHHmmss'),
  );
  const [endDate, setEndDate] = useState(null);
  const [sort, setSort] = useState({ direction: '', column: null });

  const getPaymentList = async () => {
    let start = startDate === null ? '' : dayjs(startDate).format('YYYYMMDDHHmmss');
    let end = endDate === null
        ? ''
        : dayjs(endDate).endOf('day').format('YYYYMMDDHHmmss');
    let sortBy = sort.column ? `${sort.column}:${sort.direction}` : '';

    try {
      const data = await PaymentListApi.getPaymentListApi(roleUser, start, end, page, rowsPerPage, search, sortBy)
      setPaymentListUser(data?.data);
      const newTotal = data.metadata?.total
      setTotal(newTotal);
    } catch (e) {
      console.log("Fetch data error", e)
    }
  };

  const onClickSearch = () => {
    getPaymentList();
  };
  const handleKeyEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      getPaymentList();
    }
  };

  // const onClickSorting = () => {
  //   getPaymentList();
  // };
  useEffect(() => {
    getPaymentList();
    return () => {};
  }, [rowsPerPage, page, sort]);

  return (
    <div>
      <div className="my-2 md:ml-2">
        <div className="text-lg font-light flex flex-wrap items-center ">
          <div className=" text-xl">ประวัติการชำระเงิน</div>
        </div>
        {/* <div className=" md:flex md:mt-6">
          <div className="md:w-[15%]  ">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="วันที่"
                value={startDate}
                inputFormat="DD/MM/YYYY"
                maxDate={endDate}
                onChange={(newValue) => {
                  setStartDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    sx={{ ...textFieldStyles }}
                    size="small"
                    {...params}
                  />
                )}
              />
            </LocalizationProvider>
          </div>

          <div className="md:w-[15%] md:ml-2 ">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {startDate === null || startDate === '' ? (
                <DatePicker
                  disabled
                  label="ถึง"
                  inputFormat="DD/MM/YYYY"
                  value={endDate}
                  minDate={startDate}
                  onChange={(newValue) => {
                    setEndDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      sx={{ ...textFieldStyles }}
                      {...params}
                    />
                  )}
                />
              ) : (
                <DatePicker
                  label="ถึง"
                  inputFormat="DD/MM/YYYY"
                  value={endDate}
                  minDate={startDate}
                  onChange={(newValue) => {
                    setEndDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      sx={{ ...textFieldStyles }}
                      {...params}
                    />
                  )}
                />
              )}
            </LocalizationProvider>
          </div>
          <div className="md:ml-2  md:w-[30%] ">
            <Paper
              component="form"
              sx={{
                pl: 2,
                display: 'flex',
                alignItems: 'center',
                borderRadius: '20px',
              }}
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                onKeyDown={handleKeyEnter}
                placeholder="ค้นหา"
              />
              <div className="p-[8px]">
                <SearchIcon
                  sx={{ fontSize: '22px', mr: 1, color: '#757575' }}
                />
              </div>
            </Paper>
          </div>
          <div className="md:ml-2 md:self-center ">
            <Button
              variant="contained"
              sx={{
                background: 'primary',
                color: 'white',
                borderRadius: '20px',
              }}
              onClick={() => {
                onClickSearch();
              }}
            >
              ค้นหา
            </Button>
          </div>
        </div> */}
        <div>
          <Grid container spacing={1}>
            <Grid item xs={6} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="วันที่"
                  value={startDate}
                  inputFormat="DD/MM/YYYY"
                  maxDate={endDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      sx={{ ...textFieldStyles }}
                      size="small"
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {startDate === null || startDate === '' ? (
                  <DatePicker
                    disabled
                    label="ถึง"
                    inputFormat="DD/MM/YYYY"
                    value={endDate}
                    minDate={startDate}
                    onChange={(newValue) => {
                      setEndDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        sx={{ ...textFieldStyles }}
                        {...params}
                      />
                    )}
                  />
                ) : (
                  <DatePicker
                    label="ถึง"
                    inputFormat="DD/MM/YYYY"
                    value={endDate}
                    minDate={startDate}
                    onChange={(newValue) => {
                      setEndDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        sx={{ ...textFieldStyles }}
                        {...params}
                      />
                    )}
                  />
                )}
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Paper
                component="form"
                sx={{
                  pl: 2,
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '20px',
                  justifyContent: 'space-between',
                  boxShadow: 'none',
                  border: '1px solid #CCCCCC',
                }}
              >
                <InputBase
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  onKeyDown={handleKeyEnter}
                  fullWidth
                  placeholder="ค้นหา"
                />
                <div className="p-[8px]">
                  <SearchIcon
                    sx={{ fontSize: '22px', mr: 1, color: '#757575' }}
                  />
                </div>
              </Paper>
            </Grid>
            <Grid item xs={3} md={2} lg={1}>
              <div className="">
                <Button
                  variant="contained"
                  sx={{
                    background: 'primary',
                    color: 'white',
                    borderRadius: '20px',
                  }}
                  onClick={() => {
                    onClickSearch();
                  }}
                >
                  ค้นหา
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <div className="flex flex-wrap mt-4">
        <div className="md:w-full ">
          <TablePaymentHistory
            paymentList={paymentListUser}
            rowsPerPage={rowsPerPage}
            page={page}
            total={total}
            setPage={setPage}
            setRowsPerPage={setRowsPerPage}
            setTotal={setTotal}
            sort={sort}
            setSort={setSort}
          />
        </div>
      </div>
    </div>
  );
}

export default PaymentList;
